import { useContext } from "react";
import { AppContext } from "../App";
import { MdClose, MdMenu } from "react-icons/md";

export default function MainMenuBtn(props) {
  const appContext = useContext(AppContext);

  function openSideBar() {
    appContext.setIsSideBarOpen(true);
  }

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  return (
    <button
      className="MainMenuBtn"
      data-sidebar-open={appContext.isSideBarOpen}
      onClick={appContext.isSideBarOpen ? closeSideBar : openSideBar}
      aria-label={appContext.isSideBarOpen ? "Close menu" : "Open menu"}
    >
      {appContext.isSideBarOpen ? (
        <MdClose />
      ) : (
        <MdMenu />
      )}
    </button>
  );
}
